const YOUTUBE_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'music.youtube.com',
  'youtu.be',
  'www.youtu.be',
]);

export function extractYouTubeVideoId(value: string): string | null {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  let url: URL;

  try {
    url = new URL(trimmedValue);
  } catch {
    return null;
  }

  const host = url.hostname.toLowerCase();
  if (!YOUTUBE_HOSTS.has(host)) {
    return null;
  }

  if (host.endsWith('youtu.be')) {
    return sanitizeVideoId(url.pathname.slice(1));
  }

  if (url.pathname === '/watch') {
    return sanitizeVideoId(url.searchParams.get('v'));
  }

  if (url.pathname.startsWith('/shorts/')) {
    return sanitizeVideoId(url.pathname.slice('/shorts/'.length));
  }

  if (url.pathname.startsWith('/embed/')) {
    return sanitizeVideoId(url.pathname.slice('/embed/'.length));
  }

  return null;
}

export function buildCanonicalYouTubeUrl(videoId: string): string {
  return `https://www.youtube.com/watch?v=${videoId}`;
}

export function getCanonicalYouTubeUrl(value: string): string | null {
  const videoId = extractYouTubeVideoId(value);
  return videoId ? buildCanonicalYouTubeUrl(videoId) : null;
}

function sanitizeVideoId(value: string | null): string | null {
  const trimmedValue = value?.split('/')[0]?.trim() ?? '';
  return trimmedValue ? trimmedValue : null;
}
